class BuildOutdated {
  currentBuiltAt;

  constructor(currentBuiltAt) {
    this.currentBuiltAt = new Date(currentBuiltAt);

    this._listenForNewBuild();
  }

  _checkBuild(data) {
    const config = Config.get();
    if (data.site !== config.site) {
      return;
    }

    if (new Date(data.builtAt) > this.currentBuiltAt) {
      this._showWarning(config.displaySite);
    }
  }

  _listenForNewBuild() {
    Messages.subscribe({
      channel: "apps",
      event: "new-build",
      callback: (data) => this._checkBuild(data),
    }).subscribed(async () => await this._checkApiLatestBuild());
  }

  async _checkApiLatestBuild() {
    try {
      this._checkBuild(await ApiCalls.getAppBuild());
    } catch (e) {
      return ApiError.assertIs(e);
    }
  }

  async _showWarning(displaySite) {
    const htmlContents = nunjucks.render("statusBanner/buildOutdated.njk", {
      displaySite,
    });
    StatusBanner.queueMessage({
      id: "build-outdated",
      titleContracted: "Update Ready",
      titleExpanded: "Update Ready",
      contentsHtml: htmlContents,
      priority: 2,
      displayStatus: "info",
      buttonCallback: () => window.location.reload(),
    });
  }
}

module.exports = BuildOutdated;

const ApiCalls = require("../apiCalls");
const Config = require("../config");
const ApiError = require("../errors/apiError");
const Messages = require("../messages");
const StatusBanner = require("./statusBanner");
